import { asAmount } from "@goodfill/domain-properties";
import { BalanceAccountAmountComponent } from "@goodfill/domain-properties-components";
import { Currency } from "@goodfill/models-typescript";
import { capitalizeFirstLetter } from "@goodfill/string";
import { Span, Chart, Field, Chip } from "@goodfill/ui-components";
import Decimal from "decimal.js";
import { useState } from "react";
import { AccountBondHolding } from "../../../AccountHolding";
import {
  createPortfolioDistribution,
  PortfolioDistributionGroupBy,
  portfolioDistributionGroupByValues,
} from "./createPortfolioDistribution";
import { createPortfolioDistributionChartConfiguration } from "./createPortfolioDistributionChartConfiguration";
import { PortfolioDistributionLegendTable } from "./PortfolioDistributionLegendTable";

const pieContainerStyle = {
  height: "220px",
  width: "220px",
};

export const PortfolioDistributionComponent = (props: { bondHoldings: AccountBondHolding[]; currency: Currency }) => {
  const [groupBy, setGroupBy] = useState<PortfolioDistributionGroupBy>("bond");

  const totalBondsFaceAmount = asAmount(
    props.bondHoldings.reduce((acc, bondHolding) => acc.plus(bondHolding.bondBalanceAccount.balance), new Decimal(0)),
  );
  const portfolioDistribution = createPortfolioDistribution(props.bondHoldings, totalBondsFaceAmount, groupBy);
  const pieConfiguration = createPortfolioDistributionChartConfiguration(portfolioDistribution);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row items-center justify-between my-4">
        <div className="flex flex-row items-center justify-between my-4">
          <Span font="medium" size="xl">
            Portfolio Distribution
          </Span>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-start gap-8">
        <div>
          <div style={pieContainerStyle}>
            <Chart configuration={pieConfiguration} />
          </div>
        </div>

        <div className="flex flex-col gap-2 w-full">
          <Field label="Group By">
            <div>
              {portfolioDistributionGroupByValues.map((groupByOption) => (
                <Chip
                  key={groupByOption}
                  font="medium"
                  size="small"
                  primary={groupByOption === groupBy}
                  onClick={() => setGroupBy(groupByOption)}
                >
                  {capitalizeFirstLetter(groupByOption)}
                </Chip>
              ))}
            </div>
          </Field>
          <Span size="2xl" font="semibold">
            <BalanceAccountAmountComponent value={totalBondsFaceAmount} currency={props.currency} />
          </Span>
          <PortfolioDistributionLegendTable rows={portfolioDistribution} groupBy={groupBy} />
        </div>
      </div>
    </div>
  );
};
